import api from '@/src/services/api';
import { useState } from 'react';
import { useEffect } from 'react';

export default function UniqueFacesList({
    activationId,
    baseUrl,
    slug,
}: {
    activationId: number;
    baseUrl: string;
    slug: string;
}) {
    const [faces, setFaces] = useState<any[]>([]);

    useEffect(() => {
        const fetchFaces = async () => {
            const response = await api.get(
                `/public/media/unique-faces/${activationId}`,
            );
            setFaces(response.data);
            setVisibleFaces(response.data.slice(0, 10));
        };
        fetchFaces();
    }, [activationId]);
    const [visibleFaces, setVisibleFaces] = useState<any[]>([]);

    if (faces.length === 0) {
        return null;
    }

    return (
        <div className="px-4">
            <div className="flex flex-row justify-between items-center">
                <h2 className="text-2xl font-bold">Filter By Person</h2>
            </div>
            <div className="flex flex-row mx-[20px]">
                {visibleFaces.map((face) => (
                    <div
                        key={face.faceVector}
                        className="mx-[-20px] hover:mx-[20px] transition-all duration-300 ease-in-out"
                        onClick={() => {
                            window.open(
                                `${baseUrl}/face-query/${encodeURIComponent(
                                    slug ?? '',
                                )}?faceIds=${encodeURIComponent(
                                    face.faceVector,
                                )}`,
                            );
                        }}
                    >
                        <img
                            src={face.faceCatalogUrl}
                            alt="Face"
                            className="w-16 h-16 object-cover rounded-full border-2 border-white cursor-pointer"
                        />
                    </div>
                ))}
                {faces.length > visibleFaces.length && (
                    <div className="flex flex-row items-center justify-center">
                        <button
                            onClick={() => {
                                setVisibleFaces(faces);
                            }}
                            className="cursor-pointer w-16 h-16 mx-[-20px] ease-in-out hover:mx-[20px] transition-all duration-300 bg-gray-200 text-gray-700 border-gray-500 border-2 rounded-full flex items-center justify-center"
                        >
                            + {faces.length - visibleFaces.length}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
